import React from 'react';
import { StyledButton } from '../utilities/styledComponents/StyledButton';

// eslint-disable-next-line object-curly-newline
const ActionButton = ({ id, name, func, params }) => (
	<StyledButton>
		<button type="button" className="ml-2 btn btn-register-user" onClick={func ? func.bind(this, id, params) : null}>{name}</button>
	</StyledButton>
);

export default ActionButton;
